/**
 * BankController.java 对应的 model
 */

import Model from './model'
const model = new Model()
class Account {

    /**
     * 使用 id 获取题目信息
     * @param paperId
     * @param questionIds id array
     * @returns {*}
     */
    static getQuestionsByIds(paperId, questionIds) {
        return model.post('bank/getQuestionsByIds?paperId=' + paperId, questionIds)
    }

    static runTest(params) {
        return model.post('bank/runTest', params)
    }
    static getStatQuestions(params) {
        return model.post('bank/getStatQuestions', params)
    }
}
export default Account



// WEBPACK FOOTER //
// ./bootsets/models/bank.js